// medplum-schedule.js — ONLINE-PRIMARY, same recipe as queue/patients.
// Schedule.jsx admits CLINICAL + front-desk roles; reads as the ONE logged-in
// session — RLS scopes what each sees.
import { getMedplum, deriveCurrentUser } from './client-port.js';
import { groupAppointmentBundle, buildScheduleView } from '@healther/clinical-core/shape/schedule-view.js';
import { groupEncounterBundle } from '@healther/clinical-core/shape/queue-row.js';
import { setClinicTimezone, clinicTodayKey, clinicDatePlusDays, clinicDayBounds } from '@healther/clinical-core/clinic-time.js';

const DAY_COUNT = 7;

export async function loadScheduleFromMedplum() {
  const { medplum, hospital } = await getMedplum();
  // ONE config point for clinic-local time on the client (default Asia/Kolkata).
  setClinicTimezone(hospital?.timezone);

  // Bucket by the CLINIC calendar day, and window the search to the exact UTC
  // instants that bound the clinic day range (a UTC-midnight window is off by the
  // clinic offset and drops/duplicates near-midnight rows).
  const todayKey = clinicTodayKey();
  const start = clinicDayBounds(todayKey).start;
  const end = clinicDayBounds(clinicDatePlusDays(todayKey, DAY_COUNT)).start;

  const [apptBundle, encBundle] = await Promise.all([
    // status:not=cancelled — a cancelled booking must leave the board (the shaper
    // would otherwise render it as DRAFT; availability already excludes cancelled).
    medplum.search('Appointment', `date=ge${start}&date=lt${end}&status:not=cancelled&_include=Appointment:patient&_count=500`),
    medplum.search('Encounter', `date=ge${start}&date=lt${end}&_count=500`),
  ]);
  const { patients, appts } = groupAppointmentBundle(apptBundle);
  const { encs } = groupEncounterBundle(encBundle);

  const view = buildScheduleView({ appts, patients, encs, todayKey, dayCount: DAY_COUNT });

  return { source: 'medplum-client-shaping', schedule: view, currentUser: await deriveCurrentUser(medplum), hospital };
}
